export default function isTouchScreen():boolean{
    return !!('ontouchstart' in window); 
}